import { render } from "./EditorHotspotFlyout.vue?vue&type=template&id=159fecd3&scoped=true"
import script from "./EditorHotspotFlyout.vue?vue&type=script&lang=js"
export * from "./EditorHotspotFlyout.vue?vue&type=script&lang=js"

import "./EditorHotspotFlyout.vue?vue&type=style&index=0&id=159fecd3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159fecd3"]])

export default __exports__